import { useEffect, useState } from "react";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "";

// normalizza per key stable
const safeStr = (v) => (v == null ? "" : String(v));

export default function useCityAutocomplete({
  citta,
  provincia,
  cap,
  minChars = 2,
  debounceMs = 300,
  enabled = true,
}) {
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    const q = safeStr(citta).trim();
    if (!enabled || q.length < minChars) {
      setSuggestions([]);
      setLoading(false);
      setErr("");
      return;
    }

    let aborted = false;
    setLoading(true);
    setErr("");

    const timer = setTimeout(async () => {
      try {
        const params = new URLSearchParams();
        params.set("q", q);

        // opzionali: se li passi, filtrano meglio
        const p = safeStr(provincia).trim();
        const z = safeStr(cap).trim();
        if (p) params.set("provincia", p);
        if (z) params.set("cap", z);

        const res = await fetch(
          `${API_BASE}/api/utils/search-cities?${params.toString()}`
        );
        const data = await res.json();

        if (aborted) return;
        setSuggestions(Array.isArray(data?.results) ? data.results : []);
      } catch (e) {
        if (aborted) return;
        setErr(String(e?.message || e));
        setSuggestions([]);
      } finally {
        if (!aborted) setLoading(false);
      }
    }, debounceMs);

    return () => {
      aborted = true;
      clearTimeout(timer);
    };
  }, [citta, provincia, cap, minChars, debounceMs, enabled]);

  return { suggestions, loading, err, setSuggestions };
}
